module.exports = __webpack_public_path__ + "media/hnd/bghead-b8df4e63.png";